import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'
import { shouldForwardProp } from 'helpers'

export const MaintenanceBoxWrapper = styled(Box)`
    position: relative;
    background-color: ${({ theme }) => theme.colors.warning_bg};
    padding: 16px;
    z-index: 0;
    overflow: hidden;
    border-radius: 8px;

    @media ${respondAbove.xl} {
        padding: 24px 64px 24px 24px;
    }
`

type MaintenanceTextProps = {
    hasDarkMode?: boolean
}

export const MaintenanceText = styled(Text).withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<MaintenanceTextProps>(['hasDarkMode'], prop),
})<MaintenanceTextProps>`
    color: ${({ theme, hasDarkMode }) =>
        hasDarkMode ? theme.colors.grayscale_400 : 'rgba(0, 0, 0, 0.6)'};
`

interface MaintenanceButtonProps {
    width?: number
}

export const MaintenanceButton = styled.a<MaintenanceButtonProps>`
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 0;
    color: ${({ theme }) => theme.colors.grayscale_900};
    background: ${({ theme }) => theme.colors.warning_bg};
    text-decoration: underline;

    @media ${respondAbove.xl} {
        width: ${({ width }) => (width ? `${width}px` : '100%')};
        text-decoration: none;
        font-size: 16px;
        padding: 12px;
        border-radius: 8px;
        text-align: center;
        border: ${({ theme }) => `2px solid ${theme.colors.grayscale_900}`};
    }
`

export const MaintenancePalm = styled.img`
    position: absolute;
    z-index: -1;
    right: 0;
    bottom: 0;
`

export const MaintenanceHtml = styled(Text)`
    button {
        display: block;
        font-family: ${({ theme }) => theme.fonts.text};
        font-size: ${({ theme }) =>
            theme.textVariants.bodySmall.fontSizeMobile}px;
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.secondary_500};

        @media ${respondAbove.xl} {
            font-size: ${({ theme }) =>
                theme.textVariants.bodySmall.fontSizeDesktop}px;
        }

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.secondary_700};
        }
    }
`
